<template>
  <div>
    <div class="accordion" role="tablist" v-if="project && project.salesReport">
      <div>
        <h1>{{ $t('roofLayout') }}</h1>
        <RoofLayout :cards="cards" :project="project" :referenceData="referenceData" />
      </div>
      <div>
        <h1>{{ $t('hak') }}</h1>
        <Hak :cards="cards" :project="project" :referenceData="referenceData" />
      </div>
      <div>
        <h1>{{ $t('zs') }}</h1>
        <Zs :cards="cards" :project="project" :referenceData="referenceData" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { toSalesCardInput } from '@/blocks/project/projectSalesReportDataInput';
import { ReportCardsMixin } from '@/mixins/reportCards';
import RoofLayout from './MobileSales/RoofLayout.vue';
import Hak from './MobileSales/Hak.vue';
import Zs from './MobileSales/Zs.vue';

/**
 * Cards of the tab Sales Protokoll (see feature page projekt-protokolle). In the block
 * project-sales-report-data each card is saved on its own (`saveCard`); the deprecated mobile
 * layout imports this view without it and saves the whole project.
 */
export default {
  name: 'MobileProjectsSalesReport',
  components: {
    RoofLayout,
    Hak,
    Zs,
  },
  mixins: [ReportCardsMixin],
  props: {
    project: { type: Object },
  },
  data() {
    return {
      reportPath: 'salesReport',
      cards: {
        /** Roof Layout Section */
        salesRoofSidesAttachments: {
          name: 'salesRoofSidesAttachments',
          fields: [],
          navigateTo: this.goToCard,
          successor: 'salesHakLocationState',
          predecessor: null,
          opened: true,
          completed: this.completedState,
        },

        /** HAK Section */
        salesHakLocationState: {
          name: 'salesHakLocationState',
          fields: ['salesHakLocationState'],
          navigateTo: this.goToCard,
          successor: 'salesHakAttachments',
          predecessor: 'salesRoofSidesAttachments',
          opened: false,
          completed: this.completedState,
        },
        salesHakAttachments: {
          name: 'salesHakAttachments',
          fields: [],
          navigateTo: this.goToCard,
          successor: 'salesZsLocationState',
          predecessor: 'salesHakLocationState',
          opened: false,
          completed: this.completedState,
        },

        /** ZS Section */
        salesZsLocationState: {
          name: 'salesZsLocationState',
          fields: ['salesZsLocationState'],
          navigateTo: this.goToCard,
          successor: 'salesZsWithCoverAttachments',
          predecessor: 'salesHakAttachments',
          opened: false,
          completed: this.completedState,
        },
        salesZsWithCoverAttachments: {
          name: 'salesZsWithCoverAttachments',
          fields: [],
          navigateTo: this.goToCard,
          successor: null,
          predecessor: 'salesZsLocationState',
          opened: false,
          completed: this.completedState,
        },
      },
      selectedProjectAttachmentType: null,
    };
  },

  computed: {
    isFlatRoof() {
      return this.project.measurement && this.project.measurement.roofType === 'FLAT_ROOF';
    },
    isPitchedRoof() {
      return this.project.measurement && this.project.measurement.roofType === 'PITCHED_ROOF';
    },
  },

  methods: {
    ...mapActions(['fetchEnumValues']),

    /** The sales cards have no branch targets. */
    resolveCardTarget(target) {
      return target;
    },

    toCardInput(report, fieldPaths) {
      return toSalesCardInput(report, fieldPaths);
    },
  },
  async mounted() {
    await this.fetchEnumValues('HouseLocationState');
  },
};
</script>

<style lang="scss" scoped>
/** accordion */
.accordion button {
  text-align: left;
  padding: 0.8em 0.5em;
}
.accordion .card,
.accordion .card-header {
  border: 0;
  border-radius: 0em;
}
.accordion .btn.btn-block {
  border: 0;
  border-radius: 0em;
  font-weight: bold;
}
.collapsed > .when-open,
.not-collapsed > .when-closed {
  display: none;
}
</style>
